import commonRM from './page/comm/commonRM.js';

export default {
	//option name in the two level should be the one.
	data: {
		test: 'M10,test'
	},
	cm: { //common method
		show() {
			this.log(this.test)
		},
		tabletest(e) { //当前的this 时vue 组件的this
			// console.log(e,this)
		},
		...commonRM
	},
	pm: { //the private method in a page.And use it by a method named commit in this[Project].
		
	}
}
